import axios from 'axios';
import { Helpers } from '../helpers/Helpers';

export class DeviceDataService {
    static async getDeviceDataListForMap() {
        try {
            var inputObj = {

            }

            console.log('SERVICE CALL - GetDeviceDataListForMap', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/DeviceData/GetDeviceDataListForMap', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}